import { AdTypes, PlatformTypes } from 'UI-Dash-Commons-UI';

export enum DownloadType
{
    SDK = 'sdk',
    ADAPTER = 'adapter'
}

export type ManifestExtras = {
    [PlatformTypes.IOS]?: iosManifestExtras,
    [PlatformTypes.ANDROID]?: androidManifestExtras,
    [PlatformTypes.DEFOLD]?: unrealManifestExtras,
    [PlatformTypes.UNREAL]?: unrealManifestExtras,
} & iosManifestExtras & androidManifestExtras;

type iosManifestExtras = {
    iOSAdmobRequireAppId?: boolean,
    iOSGoogleAdManagerEnableSnippet?: boolean,
    iOSPangleCaveat?: boolean,
    iOSRequiresNoAts?: boolean,
    iOSRequireSKAdnetwork?: boolean,
    iOSRequiresCalendar?: boolean,
    iOSRequiredGitLFSSection?: boolean,
    iOSFacebookCCPA?: boolean,
    iOSAmazonInitialize?: boolean,
    unityIOSAdmobRequireAppId?: boolean,
    unityAmazonIOSInitialize?: boolean,
    unrealIOSAdmobRequireAppId?: boolean,
    iOSRequiresAppDelegateWindow?: boolean,
    iOSSwiftRequirements?: boolean,
} & unityManifestExtras & unrealManifestExtras;

type androidManifestExtras = {
    androidAdmobRequireAppId?: boolean,
    androidGoogleAdManagerEnableSnippet?: boolean,
    androidMinimumSdkRequired?: boolean,
    androidMigrateToAndroidX?: boolean,
    androidRequireCleartext?: boolean,
    androidManifestMergingError?: boolean,
    androidFacebookCCPA?: boolean,
    androidAmazonInitialize?: boolean,
    androidTargetVersion31?: boolean,
    androidPangleObfuscation?: boolean,
    unityAndroidAdmobRequireAppId?: boolean,
    unityAmazonAndroidInitialize?: boolean,
    unityAndroidMinimumSdkRequired?: boolean,
    unrealAndroidAdmobRequireAppId?: boolean,
    unrealAndroidMinimumSdkRequired?: boolean,
} & unityManifestExtras & unrealManifestExtras;

type unityManifestExtras = {
    iOSPangleCaveat?: boolean,
    unityFacebookSdkMigration?: boolean,
    unityFacebookCCPA?: boolean,
    unityFacebookCCPASnippet?: boolean,
    unityAndroidManifestMergingError?: boolean,
};

type unrealManifestExtras = {
    iOSPangleCaveat?: boolean,
    unrealAarImports?: boolean,
    unrealAndroidManifestMergingError?: boolean,
    unrealAndroidAdmobRequireAppId?: boolean,
    unrealGoogleAdManager?: boolean,
    unrealFacebookCCPA?: boolean,
    unrealFacebookCCPASnippet?: boolean,
    unrealFacebookSdkMigration?: boolean,
    unrealTencentAndroid?: boolean,
};

type Download = {
    displayName: string,        // e.g. "AdColony"
    type: DownloadType,         // DownloadType.ADAPTER or .SDK
    platform: PlatformTypes,    // e.g. PlatformTypes.ANDROID, .IOS, .UNITY, .UNREAL
    size?: AdTypes[],           // e.g. [AdTypes.BANNER, .INTER, .MREC, .NATIVE, .REWARD]
    bidding?: boolean,          // Is bidding supported for this network on this platform?
    name: string,               // e.g. "ADCOLONY_NETWORK"
    version?: string,
    sdkVersion?: string,        // the current version # of the SDK for this network/platform combo, e.g. "9.15.0"
    isManualDownload?: boolean,
    sdkUrl?: string,
    adapterUrl?: string,        // absolute URL to line adapter download from applovin-mobile-artifacts.s3.amazonaws.com
    guideUrl?: string,          // relative URL to the Mediated Network Guides doc page for this network/platform
    changelogAndroid?: string,  // URL to change logs for this network/Android
    changelogiOS?: string,      // URL to change logs for this network/iOS
    headerCode?: string,        // any required additional "maven { url ... }" build.gradle line (Android)
    manifestCode?: string,
    extras?: ManifestExtras,
};

export default Download;
